import { createGraphQLClient } from '@dvag/dfs-api-client';
import { getContext, getToken } from '@dvag/dfs-orchestrator-client';
import { GraphQLClient } from 'graphql-request';
import { ApiUrls, getApiUrls } from '@dvag/dfs-constant-config/api-urls';
import { getDevEnv } from 'service/envConfig';

export const getHeaders = () => {
  const user = getContext()?.user;
  return {
    ...(user?.parentUserId ? { 'parent-user-id': user.parentUserId } : {}),
  };
};

export const getGraphQLClient = (service: keyof ApiUrls = 'person') => {
  const url = `${getApiUrls(getDevEnv())[service]}/graphql`;
  return createGraphQLClient({
    createClient: (requestMiddleware) =>
      new GraphQLClient(url, {
        credentials: 'include',
        requestMiddleware,
      }),
    getAdditionalHeaders: getHeaders,
    getToken,
  });
};
